import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid } from '@material-ui/core';

import Dialog from '../Dialog';
import MobileInput from '../MobileInput';
import { Button, Typography } from '../Wrappers/Wrappers';
import ButtonProgress from '../../commons/ButtonProgress';
import { useStyles } from './styles.js';
import { useEnterPhoneNumber } from './useEnterPhoneNumber';

const DIALOG_TITLE = 'Enter your new phone number';

function EnterPhoneNumber ({ open, onCancel, onVerify }) {
  const classes = useStyles();

  const {
    mobileValue,
    phoneError,
    getIsValid,
    isLoading,
    handleChange,
    handleCancel,
    handleVerify,
  } = useEnterPhoneNumber(open, onCancel, onVerify);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      PaperProps={{
        classes: {
          root: classes.dialogContainer,
        },
      }}
    >
      <Grid className={classes.content}>
        <Grid item container className={classNames([classes.titleSpace])}>
          <Typography weight={'medium'} variant={'h5'} className={classes.titleText}>
            {DIALOG_TITLE}
          </Typography>
        </Grid>

        <Grid item container className={classNames([classes.inputSpace])}>
          <MobileInput
            value={mobileValue}
            onChange={handleChange}
            error={!!phoneError.phone}
            helperText={phoneError.phone || 'Please enter a valid phone number'}
            placeHolderText="400123456"
            className={classes.phoneField}
          />
        </Grid>

        <Grid item container className={classNames([classes.buttonSpace])}>
          <Button
            onClick={handleCancel}
            className={classes.cancelButton}
            disabled={isLoading}
          >
            Cancel
          </Button>

          <ButtonProgress
            label="Verify"
            variant="contained"
            onClick={handleVerify}
            disabled={!getIsValid()}
            showProgress={isLoading}
            width="90px"
          />
        </Grid>
      </Grid>
    </Dialog>
  );
}

EnterPhoneNumber.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onVerify: PropTypes.func,
};

EnterPhoneNumber.defaultProps = {
  open: false,
  onCancel: () => {},
  onVerify: () => {},
};

export default observer(EnterPhoneNumber);
